import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import announcer from './aria-announcer';

document.addEventListener('DOMContentLoaded', () => {
    const $toggleBtn = document.querySelector('.btn-aside-mobile');
    const $nav = document.querySelector('.content-aside');
    const $closeBtn = document.querySelector('.btn-aside-mobile-close');

    if (!$toggleBtn || !$nav) return;

    const closeMenu = () => {
        $toggleBtn.setAttribute('aria-expanded', 'false');
        $nav.classList.remove('active');
        announcer.announce('Le menu est fermé');
        enableBodyScroll($nav);
    };

    $toggleBtn.addEventListener('click', () => {
        const isExpanded = $toggleBtn.getAttribute('aria-expanded') === 'true';
        const newState = !isExpanded;

        $toggleBtn.setAttribute('aria-expanded', String(newState));
        $nav.classList.toggle('active', newState);

        if (newState) {
            announcer.announce('Le menu est ouvert');
            disableBodyScroll($nav, {
                allowTouchMove: (el) => el.closest('.nav-mobile-panel') !== null,
            });
        } else {
            closeMenu();
        }
    });

    if ($closeBtn) {
        $closeBtn.addEventListener('click', closeMenu);
    }
});
